import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { formatCurrency, formatDate } from "@/components/pcp";
import { Calculator, Plus, CalendarBlank } from "@phosphor-icons/react";

export const STATUS_PREVISAO = {
  rascunho: { label: "Rascunho", bg: "#F4F4F5", color: "#3F3F46" },
  enviada: { label: "Enviada ao cliente", bg: "#DBEAFE", color: "#1D4ED8" },
  aprovada: { label: "Aprovada", bg: "#DCFCE7", color: "#15803D" },
  recusada: { label: "Recusada", bg: "#FEE2E2", color: "#B91C1C" },
};
export const BadgePrevisao = ({ status }) => { const s = STATUS_PREVISAO[status] || STATUS_PREVISAO.rascunho; return <span className="badge" style={{ background: s.bg, color: s.color }} data-testid={`previsao-status-${status}`}>{s.label}</span>; };

// Previsões de custos (propostas dentro do contrato): itens da planilha × quantidades previstas, ao preço do contrato
export function PrevisoesContrato({ contrato }) {
  const [lista, setLista] = useState([]);
  useEffect(() => { api.get(`/contratos/${contrato.id}/previsoes`).then((r) => setLista(r.data || [])).catch(() => null); }, [contrato.id]);
  const aprovadas = lista.filter((p) => p.status === "aprovada");
  return (
    <div className="pcp-card" style={{ padding: "12px 16px", marginTop: 20 }} data-testid="previsoes-contrato">
      <div style={{ display: "flex", alignItems: "center", gap: 12, flexWrap: "wrap", marginBottom: lista.length ? 10 : 0 }}>
        <Calculator size={18} weight="bold" />
        <div style={{ flex: 1, minWidth: 220 }}>
          <div className="font-display font-bold" style={{ fontSize: "0.9rem" }}>Previsões de custos para o cliente</div>
          <div className="text-xs" style={{ color: "#71717A" }}>{lista.length ? `${lista.length} previsão(ões) · ${aprovadas.length} aprovada(s) · ${formatCurrency(aprovadas.reduce((s, p) => s + (p.valor_total || 0), 0))} aprovados` : "Monte uma proposta com itens e quantidades da planilha, sempre ao preço do contrato; a aprovada vira OS."}</div>
        </div>
        <Link to={`/contratos/${contrato.id}/cronograma`} className="btn btn-outline btn-sm" data-testid="btn-cronograma"><CalendarBlank size={14} weight="bold" /> Cronograma de execução</Link>
        <Link to={`/contratos/${contrato.id}/previsoes/nova`} className="btn btn-primary btn-sm" data-testid="btn-nova-previsao"><Plus size={14} weight="bold" /> Nova previsão</Link>
      </div>
      {lista.length > 0 && (
        <table className="pcp-table" data-testid="previsoes-tabela">
          <thead><tr><th>Nº</th><th>Título / objeto</th><th>Local</th><th>Itens</th><th style={{ textAlign: "right" }}>Valor previsto</th><th>Status</th><th>OS</th><th>Criada em</th></tr></thead>
          <tbody>
            {lista.map((p) => (
              <tr key={p.id} data-testid={`previsao-row-${p.id}`}>
                <td className="font-mono text-xs"><Link to={`/previsoes/${p.id}`} style={{ fontWeight: 700 }} data-testid={`previsao-link-${p.id}`}>{p.numero}</Link></td>
                <td>{p.titulo || p.objeto || "—"}</td>
                <td className="text-xs">{[p.rodovia, p.trecho, p.municipio].filter(Boolean).join(" · ") || "—"}</td>
                <td>{p.itens?.length || 0}</td>
                <td className="font-mono" style={{ textAlign: "right", fontWeight: 700 }}>{formatCurrency(p.valor_total)}</td>
                <td><BadgePrevisao status={p.status} /></td>
                <td className="text-xs">{p.os_id ? <Link to={`/ordens/${p.os_id}`}>{p.os_numero}</Link> : "—"}</td>
                <td className="font-mono text-xs">{formatDate(p.created_at)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
